/**
 * @file
 * The popover search box.
 */

((Drupal) => {
  const { berTags } = Drupal;
  const { components } = berTags;
  const { el } = berTags.dom;

  // Header search box. Enter must not submit the surrounding entity form.
  components.searchBox = ({ onSearch }) => {
    const search = el('input', 'ber-tags__search');
    search.type = 'search';
    search.placeholder = Drupal.t('Search');
    search.setAttribute('aria-label', Drupal.t('Search options'));
    search.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
      }
    });
    search.addEventListener('input', () => onSearch(search.value));
    return search;
  };
})(Drupal);
